import React, { ReactElement } from 'react';
import { EmbeddedLoginErrorText } from './EmbeddedLoginErrorText';
import { EmbeddedLoginError as EmbeddedLoginErrorCore } from '@instinet-analytics/semantic-ui-components';
import { useReloadRequired } from 'embedded/api/hooks/useReloadRequired';
import { useDispatchSupportRequestAction } from 'app/contactSupport/store/dispatcher';
import { VersionWarnings } from 'app/VersionWarnings/VersionWarnings';

export interface EmbeddedLoginErrorProps {
    text: EmbeddedLoginErrorText;
    hideReload?: boolean;
}

export default function EmbeddedLoginError(
    props: EmbeddedLoginErrorProps
): ReactElement {
    const { hideReload, text } = props;

    const { onReloadClicked } = useReloadRequired();
    const dispatchSupportRequest = useDispatchSupportRequestAction();

    return (
        <EmbeddedLoginErrorCore
            hideReload={hideReload}
            text={text}
            onContactSupportClicked={dispatchSupportRequest}
            onReloadClicked={onReloadClicked}
            prefix={
                <VersionWarnings clientWarnings={true} showRecommended={true} />
            }
        />
    );
}
